import React from 'react';
import { Box, Stack, useToast } from '@chakra-ui/react';
import UploadedImage from './UploadedImage';
import UploadImageUI from './UploadImageUI';
import ImageUploading from 'react-images-uploading';
import { useMutation } from '@apollo/client';
import { useDispatch, useSelector } from 'react-redux';
import { setImages } from '../../../redux/imagesSlice';
import queries from '../../../utils/query';
import { selectMockImages, setMockProduct } from '../../../redux/mockImagesSlice';

const ProductImageAccordion = ({ viewId }) => {
	const mockImages = useSelector(selectMockImages);
	const type = 'product';
	const toast = useToast();
	const [updateMockViewImages, { loading: mutationMockLoading, error: mutationMockError }] = useMutation(
		queries.UPDATE_VIEW_MOCK_IMAGES,
	);
	const [uploadImage, setUploadImage] = React.useState([]);
	const maxNumber = 1;
	const updateRedux = setMockProduct;

	React.useEffect(() => {
		if (mockImages) {
			updateMockViewImages({
				variables: {
					viewId: String(viewId),
					mockImages: JSON.stringify(mockImages),
				},
			});
		}
	}, [mockImages]);

	React.useEffect(() => {
		if (mutationMockError) {
			toast(mutationErrorMessage);
		}
	}, [mutationMockError]);

	return (
		<Box>
			<Stack>
				<ImageUploading
					onChange={setUploadImage}
					value={uploadImage}
					maxNumber={maxNumber}
					dataURLKey="data_url"
					acceptType={['jpg', 'png', 'jpeg', 'gif']}
				>
					{(imageUploadProps) => (
						<UploadImageUI
							{...{
								...imageUploadProps,
								updateRedux,
								images: mockImages?.[type],
								uploadImage,
								setUploadImage,
								isLoading: mutationMockLoading,
							}}
						/>
					)}
				</ImageUploading>
				{mockImages?.[type]?.map((image, index) => (
					<UploadedImage
						key={'product-upload-image-' + index}
						{...{ image, index, images: mockImages[type], updateRedux, type, noCopy: true }}
					/>
				))}
			</Stack>
		</Box>
	);
};

export default ProductImageAccordion;

const mutationErrorMessage = {
	title: 'Ocorreu um erro ao tentar salvar as imagens no banco',
	status: 'error',
	duration: '4000',
	isClosable: true,
};
